import { t } from "@lingui/macro";
import React from "react";

import {
  HStack,
  Text,
  Box,
} from "../../../../../../../../components/primitive";

type PlayerDetailBannerProps = {
  fullName: string;
  icons?: React.JSX.Element;
  isGuest?: boolean;
};

export const PlayerDetailBanner = ({
  fullName,
  icons,
  isGuest,
}: PlayerDetailBannerProps) => {
  return (
    <HStack alignItems="center" pr={4} gap={2} mt={1}>
      {icons ? icons : null}
      <Text variant="mainSmallSemiBold">{fullName}</Text>
      {isGuest ? (
        <Box
          backgroundColor="main-secondary-500"
          width={16}
          height={16}
          justifyContent="center"
          alignItems="center"
          style={{ borderRadius: 4 }}
        >
          <Text variant="mainTiny" color="text-inverse">{t`G`}</Text>
        </Box>
      ) : null}
    </HStack>
  );
};
